<template>
  <div class="main-content">
    <div class="container">
      <div ref="daySelector" />
      <h3 v-if="selected.duration === 'day'">
        {{ getMonthText() }}
      </h3>
      <DaySelector :selected.sync="selected" v-bind="$props" @change="onChangeSelected" />
      <CategorySelector :selected.sync="selected" :event-categories="eventCategories" v-bind="$props" @change="onChangeSelected" />
      <Events :selected.sync="selected" v-bind="$props" class="events" :is-loading="isLoading" @close="onClose" />
      <FooterDaySelector :selected.sync="selected" v-bind="$props" class="footer-day-selector" @change="onChangeSelected" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import DaySelector from '@/components/DaySelector'
import FooterDaySelector from '@/components/FooterDaySelector'
import CategorySelector from '@/components/CategorySelector'
import Events from '@/components/Events'

export default {
  components: {
    DaySelector,
    FooterDaySelector,
    CategorySelector,
    Events
  },
  props: [
    'selected',
    'events',
    'isLoading',
    'eventCategories'
  ],
  methods: {
    getMonthText () {
      const month = _.toUpper(moment(this.selected.date).format('MMMM'))
      return this.$filters.translate(`T_${month}`)
    },
    onChangeSelected () {
      this.$emit('update:selected', this.selected)
      this.$emit('change', this.selected)
    },
    onClose () {
      _.set(this.selected, 'searchText', null)
      this.$emit('close')
    },
    scrollToDaySelector () {
      this.$refs.daySelector.scrollIntoView({ behavior: 'instant' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/_variables.scss';

.main-content {
  position: relative;
  z-index: 1;
  display:flex;
  justify-content: right;
  // margin-left: 190px;
  .container {
    // border: 1px red solid;
    min-width: calc(1280px - 60px);
    width: calc(100vw - 190px);
    min-height: 800px;
    background-color: white;
    border-radius: 25px 0px 0px 0px;
    padding: 100px 110px 60px 50px;
  }
}

h3 {
  color: #404851;
  font-size: 34px;
  font-weight: 700;
  margin-left: 30px;
  margin-bottom: 27px;
  font-family: Poppins-Medium;
  font-weight: 700;
}

.events {
  margin-top: 36px;
}

@media screen and (min-width: 1800px)
{
  .main-content {
    .container {
      padding: 100px $main-content-1800-padding-right 60px 50px;
    }
  }
}

@media screen and (max-width: 1280px)
{
  .main-content {
    .container {
      min-width: calc(100px);
      width: calc(100vw);
      padding: 100px 50px 60px 50px;

    }
  }
  h3 {
    margin-left: 0px;
  }
  .events {
  margin-top: 26px;
}
}

@media screen and (max-width: 768px)
{
  .main-content {
    .container {
      padding-top: 0px;
      padding: 0px;
      border-radius: 0px 0px 0px 0px;
      h3 {
        display: none;
      }
    }
  }
}
</style>
